import { render, staticRenderFns } from "./CardMonitor.vue?vue&type=template&id=4070612a"
import script from "./CardMonitor.vue?vue&type=script&lang=js"
export * from "./CardMonitor.vue?vue&type=script&lang=js"
import style0 from "./CardMonitor.vue?vue&type=style&index=0&id=4070612a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4070612a')) {
      api.createRecord('4070612a', component.options)
    } else {
      api.reload('4070612a', component.options)
    }
    module.hot.accept("./CardMonitor.vue?vue&type=template&id=4070612a", function () {
      api.rerender('4070612a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardMonitor.vue"
export default component.exports